import classNames from "classnames";
import React, { createRef, useState } from "react";
import styles from "./image.module.css"

export default function Image({ src, aspectRatio, alt = "", type, dynamicObjectFit = false, fullScreen = false }){
  const types = {
    small: "200x200",
    medium: "720x405",
    large: "1920x1080"
  }

  const imgEl = createRef();
  const [ objectFit, setObjectFit ] = useState("cover")

  if (!types[type]) {
    console.error("Unknown Image type");
    return null;
  }

  const imageSrc = () => {
    if (!src) return "";

    const urlParts = src.split("%2F");
    const newUrlParts = urlParts.map((part, index) => {
      if (index === urlParts.length - 1) {
        return `resized%2F${part.replace(/\.(jpg|jpeg|png|webp)/i, `_${types[type]}.webp`)}`;
      } else {
        return part;
      }
    });

    return newUrlParts.join("%2F");
  }
  
  const changeObjectFit = ({ height, width }) => {
    if (height > width) setObjectFit("contain")
  }

  return (
    <div className={classNames(styles.imageContainer, { [styles.imageContainerFullScreen ]: fullScreen })} style={aspectRatio ? { aspectRatio: aspectRatio } : {}}>
      {dynamicObjectFit ? (
        <img 
          className={styles.imageBg} 
          src={imageSrc()} 
          alt="" 
          ref={imgEl}
        />
      ) : null}
      <img 
        style={{ objectFit }}
        className={classNames(styles.image, { [styles.imageDynamicObjectFit]: dynamicObjectFit })} 
        src={imageSrc()} 
        alt={alt} 
        ref={imgEl}
        onLoad={() => {
          if (dynamicObjectFit) {
            changeObjectFit({
              height: imgEl.current.naturalHeight,
              width: imgEl.current.naturalWidth
            })
          }
        }} 
      />
    </div>
  );
}